import { MichelinBibIcon, MichelinNewIcon } from '@local/assets/icons'

import { getMichelinStarIcon } from '@web/components/PlaceAwards/PlaceAwards.helper'
import { gql } from '@web/gql'
import { MichelinGuideAwards_PlaceFragment } from '@web/gql/graphql'

import styles from './PlaceAwards.module.scss'

const MichelinGuideAwardsFragment = gql(`
  fragment MichelinGuideAwards_Place on Place {
    id
    michelinGuide {
        year
        type
        starCount
        region
      }
  }
`)

type Props = {
  place: MichelinGuideAwards_PlaceFragment
}

const MichelinGuideAwards = ({ place }: Props) => {
  const { michelinGuide } = place

  if (michelinGuide) {
    const michelinStarForDisplay = getMichelinStarIcon(michelinGuide)
    return (
      <div className={styles.michelin_area}>
        <span className={styles.michelin_pictogram}>
          {michelinGuide.type === 'bib' && <MichelinBibIcon className={styles.icon_star_b} />}
          {michelinStarForDisplay && (
            <michelinStarForDisplay.Icon className={michelinStarForDisplay.style} aria-hidden="true" />
          )}
          {michelinGuide.type === 'new' && <MichelinNewIcon className={styles.icon_star_new} />}
        </span>
        미쉐린 가이드 {michelinGuide.region} {michelinGuide.year}
      </div>
    )
  }

  return null
}

export default MichelinGuideAwards
